import FileSaver from 'file-saver';

export const downloadCodeFile = (text, fileName) => {
  const blobData = new window.Blob([text], {
    type: 'text/plan;charset=utf-8'
  });

  FileSaver.saveAs(blobData, fileName);
};
